<script>
import WindowSize from '@/mixins/window-size'

export default {
  name: 'BaseButton',
  mixins: [WindowSize],
  props: {
    disabled: Proptypes.boolean(false),
    clickableWhenDisabled: Proptypes.boolean(false),
    id: Proptypes.string(''),
    color: Proptypes.string('primary'),
  },
  computed: {
    shouldDisableButton() {
      if (this.clickableWhenDisabled) {
        return false
      }

      return this.disabled
    },
    containerClass() {
      const classes = ['tamara-base-button']

      if (this.disabled) {
        classes.push('tamara-base-button--disabled')
      }

      return classes
    },
  },
}
</script>

<template>
  <v-btn
    :id="id"
    :class="containerClass"
    :disabled="shouldDisableButton"
    :large="isMobile"
    :x-large="isDesktop"
    :color="color"
    width="100%"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
  </v-btn>
</template>

<style lang="scss">
.v-application.tamara-application {
  .tamara-base-button {
    &.tamara-base-button--disabled {
      box-shadow: none !important;
      color: #999 !important;
      background-color: #e5e5e5 !important;
      transition: all 300ms linear;
    }

    &.v-btn {
      &--text {
        background-color: transparent !important;
        border: none;
        color: #000;
        font-size: 14px;
        font-weight: 700;
        line-height: 20px;
        text-align: center;
      }
    }
  }
}
</style>
